import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-da5e82ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sms-balance" };
const _hoisted_2 = { class: "sms-balance__container" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "sms-balance__container" };
const _hoisted_5 = ["innerHTML"];
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useSmsBalance } from '@/features/SMSCampaigns/composables/useSmsBalance';
import { formatNumber } from '@/utilities/formatters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSBalance',
    setup(__props) {
        const store = useStore();
        const { updateBalance, loadingBalance } = useSmsBalance();
        const balance = computed(() => formatNumber(store.state.smsCampaigns.balance));
        const date = computed(() => store.state.smsCampaigns.updatedAt.date);
        const hours = computed(() => store.state.smsCampaigns.updatedAt.hour);
        onMounted(() => {
            updateBalance();
        });
        return (_ctx, _cache) => {
            const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
            const _component_el_skeleton = _resolveComponent("el-skeleton");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_skeleton, {
                        loading: _unref(loadingBalance),
                        animated: ""
                    }, {
                        template: _withCtx(() => [
                            _createVNode(_component_el_skeleton_item, {
                                variant: "p",
                                class: "sms-balance__skeleton"
                            })
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("span", {
                                innerHTML: _ctx.$t('sms-campaigns.balance.count', { count: balance.value })
                            }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                    }, 8, ["loading"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_skeleton, {
                        loading: _unref(loadingBalance),
                        animated: ""
                    }, {
                        template: _withCtx(() => [
                            _createVNode(_component_el_skeleton_item, {
                                variant: "p",
                                class: "sms-balance__skeleton"
                            })
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("span", {
                                innerHTML: _ctx.$t('sms-campaigns.balance.updated', { date: date.value, hours: hours.value })
                            }, null, 8, _hoisted_5)
                        ]),
                        _: 1
                    }, 8, ["loading"])
                ])
            ]));
        };
    }
});
